export default "__VITE_ASSET__66a8d291__"